import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { FormControl } from '@angular/forms';
import { TicketActionsService } from 'src/app/services/ticket/ticket-actions.service';
import { AuthService } from 'src/app/services/auth.service';
import { RecentTicket } from 'src/app/models/core/recent-ticket.model';
@Component({
  selector: 'app-delete-ticket-modal',
  templateUrl: './delete-ticket-modal.component.html',
  styleUrls: ['./delete-ticket-modal.component.scss'],
  standalone: false
})
export class DeleteTicketModalComponent {
  @Input() ticket!: RecentTicket;
  @Input() eventId!: number;
  @Input() onSuccess?: () => void;
  public reasonControl = new FormControl('');

  constructor(
    private modalCtrl: ModalController,
    private ticketActions: TicketActionsService,
    private authService: AuthService,
  ) { }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  async onSubmitDeletePetition() {
    const reason = this.reasonControl.value?.trim();

    if (!reason) {
      this.ticketActions.showError('delete-ticket-modal.empty-reason');
      return;
    }

    const userData = await this.authService.getLogin();
    const userId = userData?.user?.id;

    if (!userId) {
      console.error('No se pudo obtener el ID del usuario');
      return;
    }

    const body = {
      event_id: this.eventId,
      reason: this.reasonControl.value,
      ticket_id: this.ticket.id,
      user_id: userId,
      type: 'delete',
    };

    this.ticketActions.sendDeletePetition(body, () => {
      if (this.onSuccess) {
        this.onSuccess();
      }

      setTimeout(() => {
        this.scrollToTop();
      }, 200);

      this.closeModal();
    });
  }

  private scrollToTop() {
    const ionContent = document.querySelector('ion-content');
    if (ionContent) {
      ionContent.scrollToTop(300);
    }
  }

  get hasPendingDeletePetition(): boolean {
    const p = this.ticket.latest_petition;
    if (!p) return false;

    const status = (p.status ?? '').toLowerCase();
    const pType = (p.type ?? '').toLowerCase();

    if (status !== 'pending') return false;
    return pType === 'delete';
  }

  getTicketAmount(ticket: RecentTicket): number {
    return ticket.price_product ? ticket.price_product * ticket.quota : 0;
  }

  shouldShowReference(): boolean {
    const ref = this.ticket?.reference || '';
    return ref.toUpperCase() !== 'SIN REFERENCIA';
  }
}
